import ErrorIcon from "@mui/icons-material/Error";
import { CircularProgress } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import WarningIcon from "@mui/icons-material/Warning";
import { colorsList } from "./colorsList";

export const iconComp = {
  warning: { Comp: WarningIcon, color: colorsList.yellow },
  error: { Comp: ErrorIcon, color: colorsList.red },
  loading: { Comp: CircularProgress, color: colorsList.blue },
  logout: { Comp: LogoutIcon, color: colorsList.red },
};

export const user = {
  id: 1,
  name: "user",
  lang: "ing",
  avatar: 12,
  group: 1,
  ter: false,
  tername: false,
  date: false,
  schedule: {},
  isMobile: false,
  tile: "OSM",
};

export const asianFormat = ["ch", "chs"];

export const inputParams = {
  userName: { minLength: 3, maxLength: 9 },
  terName: { minLength: 3, maxLength: 17 },
};

export const emptys = [null, undefined, "", false];

export const colors = {
  single: [colorsList.red, colorsList.lightYellow],
  group: [colorsList.green, colorsList.lightYellow],
  done: [colorsList.grey, colorsList.white],
};

export var warningAlerts = {};

export const mapsUrl = {
  google: "https://www.google.com/maps/search/?api=1&query={coords}",
  waze: "https://waze.com/ul?ll={coords}&navigate=yes",
};
